export default ({ request }) => ({
  tcExpenseListApi(data = {}) {
    return request({
      url: '/factory/tc/expense/list',
      method: 'post',
      data,
    })
  },
  tcExpenseSaveApi(data = {}) {
    return request({
      url: '/factory/tc/expense/save',
      method: 'post',
      data,
    })
  },
  tcExpenseDetailApi(data = {}) {
    return request({
      url: '/factory/tc/expense/detail',
      method: 'post',
      data,
    })
  },
  tcExpenseDelApi(data = {}) {
    return request({
      url: '/factory/tc/expense/del',
      method: 'post',
      data,
    })
  },
  tcExpenseFindDepApi(data = {}) {
    return request({
      url: '/factory/tc/expense/findDep',
      method: 'post',
      data,
    })
  },
  tcExpenseSubmitAuditApi(data = {}) {
    return request({
      url: '/factory/tc/expense/submit',
      method: 'post',
      data,
    })
  },
  tcExpenseSubmitOaApplyApi(data = {}) {
    return request({
      url: '/oa/tc/expense/apply',
      method: 'post',
      data,
    })
  },
  tcExpenseItemListApi(data = {}) {
    return request({
      url: '/factory/tc/expense/item/list',
      method: 'post',
      data,
    })
  },
  tcExpenseDocistApi(data = {}) {
    return request({
      url: '/factory/tc/expense/doc/list',
      method: 'post',
      data,
    })
  },
  //查询银行账户信息接口
  masterCustomerBankListApi(data = {}) {
    return request({
      url: '/digitalCenter/master/customer/bank/list',
      method: 'post',
      data,
    })
  },
  masterScmInfoBankListApi(data = {}) {
    return request({
      url: '/digitalCenter/scmInfo/bank/list',
      method: 'post',
      data,
    })
  },
})
